export const COLORS = {
  white: "#ffffff",
  synapsesBlack: "#222021",
  lightGrey: "rgba(244, 244, 244, 1)",
  blankGrey: "#a0a0a0"
};
